module.exports = "<div>\ndsfas  dsfdafsaf ddfdas    \n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = main